import './App.css';
import { Routes, Route, useParams } from 'react-router-dom'
import HomePage from './HomePage/HomePage'
import IsecDashboard from './Isecurion-components/Pages/IsecDashboard';
import Status from './Isecurion-components/Pages/Status';
import AddVulnerability from './Isecurion-components/Pages/AddVulnerability';
import Messenger from './Isecurion-components/Pages/Messenger';
import ClientDashboard from './Client-components/Pages/ClientDashboard';
import Client_Messenger from './Client-components/Pages/Client_Messenger'
import ProtectedRoute from './Context/ProtectedRoute';
import ClientProtected from './Context/ClientProtected';
import Error from './ErrorPage/Error';
import Report from './Isecurion-components/Pages/Report';
import ResetPassword from './HomePage/ResetPassword';
import { UserAuthProvider } from './Context/UserContext';
import SessionTimeout from './SessionTimeout/SessionTimeout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import User from './Isecurion-components/Pages/User';
import UpdateUser from './HomePage/UpdateUser';
import IsecProjectTable from './Isecurion-components/Pages/IsecProjectTable';
import ClientProjectTable from './Client-components/Pages/ClientProjectTable';
import Client_RegisterUser from './Client-components/Pages/Client_RegisterUser';
import { LoginPage } from './HomePage/LoginPage';
import ForgotPage from './HomePage/ForgotPage';
import VulnerabilityPage from './Isecurion-components/Pages/VulnerabilityPage';
import OpenVulnerabilities from './Client-components/Pages/OpenVulnerabilities';
import ViewVulnerabilities from './Client-components/Pages/ViewVulnerabilities';
import IsecViewVulnerabilities from './Isecurion-components/Pages/ViewVulnerabilities';
import FeedbackForm from './Isecurion-components/Pages/Feedback';

function App() {

  const { projectId } = useParams();


  return (

    <div className="App">

      <UserAuthProvider>
        <Routes>
          <Route
            exact path='/'
            element={<HomePage />}>
          </Route>


          <Route
            exact path='/login'
            element={<LoginPage />}>
          </Route>

          <Route
            exact path='/forgotpasswordpage'
            element={<ForgotPage />}>
          </Route>

          <Route
            exact path='/create-password/:token'
            element={<UpdateUser />}>
          </Route>

          <Route
            exact path='/isecurion_dash'
            element={<ProtectedRoute><IsecDashboard /></ProtectedRoute>}>
          </Route>

          <Route
            exact path='/isecurion/projects/all'
            element={<ProtectedRoute><IsecProjectTable /></ProtectedRoute>}>
          </Route>

          <Route
            exact path='/projects/status/:projectid'
            element={<ProtectedRoute><Status project={projectId} /></ProtectedRoute>}>
          </Route>``

          <Route
            exact path='/isecurion/viewvulnerabilities/:id'
            element={<ProtectedRoute><IsecViewVulnerabilities /></ProtectedRoute>} >
          </Route>


          <Route
            exact path='/isecurion_dash/status/:projectid/addvuln'
            element={<ProtectedRoute><AddVulnerability /></ProtectedRoute>}>
          </Route>

          <Route
            exact path='/isecurion/messenger'
            element={<ProtectedRoute><Messenger /></ProtectedRoute>}>
          </Route>

          <Route
            exact path='/isecurion/adduser'
            element={<ProtectedRoute><User /></ProtectedRoute>}>
          </Route>


          <Route
            exact path='/isecurion/vulnerabilities'
            element={<ProtectedRoute><VulnerabilityPage /></ProtectedRoute>}>
          </Route>

          <Route exact path='/isecurion/generatereport'
            element={<ProtectedRoute><Report /></ProtectedRoute>}>
          </Route>

          <Route
            exact path='/client_dashboard'
            element={<ClientProtected><ClientDashboard /></ClientProtected>}>
          </Route>

          <Route
            exact path='/openvulnerabilities'
            element={<ClientProtected><OpenVulnerabilities /></ClientProtected>}>
          </Route>
          <Route
            exact path='/viewvulnerabilities/:id'
            element={<ClientProtected><ViewVulnerabilities /></ClientProtected>}>
          </Route>

          <Route
            exact path='/projects/all'
            element={<ClientProtected><ClientProjectTable /></ClientProtected>}>
          </Route>

          <Route
            exact path='/client/register developer'
            element={<ClientProtected><Client_RegisterUser /></ClientProtected>}>
          </Route>


          <Route
            exact path='/client/chatbox'
            element={<ClientProtected><Client_Messenger /></ClientProtected>}>
          </Route>

          <Route
            exact path='*'
            element={<Error />}>
          </Route>

          <Route
            exact path='/resetpassword/:resetToken'
            element={<ResetPassword />}
          ></Route>

          <Route
            exact path='/feedback/:token'
            element={<FeedbackForm />}
          ></Route>

        </Routes>
        <SessionTimeout />
        <ToastContainer />
      </UserAuthProvider>
    </div>

  );
}

export default App;
